'use client';

import NavFooterLayout from 'src/components/Layouts/NavFooterLayout';
import ErrorPage from 'src/components/ErrorPage';

const Error = ({ error }: { error: any }) => {
	return (
		<NavFooterLayout>
			<ErrorPage error={error} />
		</NavFooterLayout>
	);
};

export default Error;
